"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var InsertLink_exports = {};
__export(InsertLink_exports, {
  default: () => InsertLink_default
});
module.exports = __toCommonJS(InsertLink_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.6758 8.53125C15.3372 8.38802 14.9401 8.3099 14.4844 8.29688C14.0286 8.27083 13.5339 8.25781 13 8.25781C12.8568 8.25781 12.7331 8.21224 12.6289 8.12109C12.5378 8.01693 12.4922 7.89323 12.4922 7.75C12.4922 7.60677 12.5378 7.48958 12.6289 7.39844C12.7331 7.29427 12.8568 7.24219 13 7.24219C13.013 7.24219 13.0195 7.24219 13.0195 7.24219C13.0326 7.24219 13.0456 7.24219 13.0586 7.24219C13.5534 7.24219 14.0677 7.26172 14.6016 7.30078C15.1354 7.32682 15.6172 7.42448 16.0469 7.59375C16.2812 7.6849 16.4961 7.80859 16.6914 7.96484C16.8997 8.12109 17.0755 8.3099 17.2188 8.53125C17.375 8.7526 17.4857 9.00651 17.5508 9.29297C17.6289 9.57943 17.668 9.89844 17.668 10.25C17.668 10.6016 17.6289 10.9206 17.5508 11.207C17.4857 11.4935 17.375 11.7474 17.2188 11.9688C17.0755 12.1901 16.8997 12.3789 16.6914 12.5352C16.4961 12.6914 16.2812 12.8151 16.0469 12.9062C15.6172 13.0755 15.1354 13.1797 14.6016 13.2188C14.0677 13.2448 13.5534 13.2578 13.0586 13.2578C13.0456 13.2578 13.0326 13.2578 13.0195 13.2578C13.0195 13.2578 13.013 13.2578 13 13.2578C12.8568 13.2578 12.7331 13.2122 12.6289 13.1211C12.5378 13.0169 12.4922 12.8932 12.4922 12.75C12.4922 12.6068 12.5378 12.4896 12.6289 12.3984C12.7331 12.2943 12.8568 12.2422 13 12.2422C13.5339 12.2422 14.0286 12.2357 14.4844 12.2227C14.9401 12.1966 15.3372 12.112 15.6758 11.9688C15.832 11.9036 15.9688 11.832 16.0859 11.7539C16.2031 11.6628 16.3073 11.5521 16.3984 11.4219C16.4766 11.2917 16.5417 11.1354 16.5938 10.9531C16.6458 10.7578 16.6719 10.5234 16.6719 10.25C16.6719 9.97656 16.6458 9.7487 16.5938 9.56641C16.5417 9.37109 16.4766 9.20833 16.3984 9.07812C16.3073 8.94792 16.2031 8.84375 16.0859 8.76562C15.9688 8.67448 15.832 8.59635 15.6758 8.53125ZM5.20703 11.9883C5.50651 12.1185 5.85156 12.1966 6.24219 12.2227C6.64583 12.2357 7.09505 12.2422 7.58984 12.2422C7.72005 12.2422 7.83073 12.2943 7.92188 12.3984C8.02604 12.4896 8.07812 12.6068 8.07812 12.75C8.07812 12.8932 8.02604 13.0169 7.92188 13.1211C7.83073 13.2122 7.72005 13.2578 7.58984 13.2578C7.57682 13.2578 7.5638 13.2578 7.55078 13.2578C7.53776 13.2578 7.52474 13.2578 7.51172 13.2578C7.06901 13.2578 6.60677 13.2448 6.125 13.2188C5.64323 13.1797 5.20052 13.069 4.79688 12.8867C4.58854 12.7956 4.38672 12.6719 4.19141 12.5156C4.00911 12.3594 3.85286 12.1706 3.72266 11.9492C3.59245 11.7279 3.49479 11.474 3.42969 11.1875C3.36458 10.901 3.33203 10.5885 3.33203 10.25C3.33203 9.91146 3.36458 9.59896 3.42969 9.3125C3.49479 9.02604 3.59245 8.77214 3.72266 8.55078C3.85286 8.32943 4.00911 8.14062 4.19141 7.98438C4.38672 7.82812 4.58854 7.70443 4.79688 7.61328C5.20052 7.43099 5.64323 7.32682 6.125 7.30078C6.60677 7.26172 7.06901 7.24219 7.51172 7.24219C7.52474 7.24219 7.53776 7.24219 7.55078 7.24219C7.5638 7.24219 7.57682 7.24219 7.58984 7.24219C7.72005 7.24219 7.83073 7.29427 7.92188 7.39844C8.02604 7.48958 8.07812 7.60677 8.07812 7.75C8.07812 7.89323 8.02604 8.01693 7.92188 8.12109C7.83073 8.21224 7.72005 8.25781 7.58984 8.25781C7.09505 8.25781 6.64583 8.27083 6.24219 8.29688C5.85156 8.3099 5.50651 8.38151 5.20703 8.51172C5.07682 8.57682 4.95964 8.65495 4.85547 8.74609C4.7513 8.82422 4.66016 8.92839 4.58203 9.05859C4.51693 9.1888 4.45833 9.35156 4.40625 9.54688C4.35417 9.72917 4.32812 9.96354 4.32812 10.25C4.32812 10.5365 4.35417 10.7773 4.40625 10.9727C4.45833 11.1549 4.51693 11.3112 4.58203 11.4414C4.66016 11.5716 4.7513 11.6823 4.85547 11.7734C4.95964 11.8516 5.07682 11.9232 5.20703 11.9883ZM13.5078 10.25C13.5078 10.3932 13.4557 10.5169 13.3516 10.6211C13.2604 10.7122 13.1432 10.7578 13 10.7578H8C7.85677 10.7578 7.73307 10.7122 7.62891 10.6211C7.53776 10.5169 7.49219 10.3932 7.49219 10.25C7.49219 10.1068 7.53776 9.98958 7.62891 9.89844C7.73307 9.79427 7.85677 9.74219 8 9.74219H13C13.1432 9.74219 13.2604 9.79427 13.3516 9.89844C13.4557 9.98958 13.5078 10.1068 13.5078 10.25Z",
      fill: "currentColor"
    }
  )
);
const SvgInsertLink = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var InsertLink_default = SvgInsertLink;
